import React from 'react';
import PropTypes from 'prop-types';
import WithHover from 'WithHover';

export const SidebarDownloadDocButton = (props) => {
  const imgSrc = props.isHover ? props.imgSrcHover : props.imgSrc;
  const { slug, format } = props;
  const linkProps = {
    target: '_blank',
    rel: 'noreferrer noopener',
    href: `${window.formswiftUrl}/downloads/${slug}/${slug}.${format}`,
  };
  if (format !== 'pdf') {
    linkProps.download = true;
  }
  return (
    <div
      className="rank-brain-2-sidebar-download-doc-button"
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      <a {...linkProps}>
        <img alt="Download" src={imgSrc} />
        {props.text}
      </a>
    </div>
  );
};

SidebarDownloadDocButton.defaultProps = {
  isHover: false,
};

SidebarDownloadDocButton.propTypes = {
  isHover: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  imgSrcHover: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
};

const SidebarDownloadDocButtonWithHover = WithHover(SidebarDownloadDocButton);

export default SidebarDownloadDocButtonWithHover;



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarDownloadSection/SidebarDownloadDocButton.jsx